import { Star } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function EmployeeReviewsPage() {
  return (
    <PhaseStubPage
      title="Employee Reviews"
      phase={6}
      modules={[
        'Per-employee review history (self-service, own records only)',
        'Review cycles with manager + peer input',
        'Goals / OKRs tied to each cycle',
        'Manager write surface for drafting and publishing reviews',
        'PDF export of finalized review packets',
      ]}
      icon={Star}
    />
  );
}
